/**
 * Frontend route paths
 * Centralized location for all application routes
 */
export const AppRoutes = {
  LOGIBLOCKS: '/logiblocks',
  LOGIBLOCKS_CANVAS: (workflowId: string) =>
    `/logiblocks?view=canvas&workflow=${workflowId}`,
  /** The canvas of a workflow, opened on its Runs tab with this run selected. */
  LOGIBLOCKS_RUN: (workflowId: string, runId: string) =>
    `/logiblocks?view=canvas&workflow=${workflowId}&run=${runId}`,
} as const;
